import React from 'react';
import '../../styles/videoband.css';

/* Full-screen cinematic video band with caption. File in public/calf.mp4 */
const SRC = `${process.env.PUBLIC_URL}/calf.mp4`;
const SPEED = 0.6; // slow-motion playback

export default function VideoBand() {
  const setSpeed = (e) => {
    e.currentTarget.playbackRate = SPEED;
  };

  return (
    <section className="video-band" aria-label="Life on the farm">
      <video
        className="video-band__player"
        src={SRC}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
        onLoadedMetadata={setSpeed}
      />
      <div className="video-band__overlay" aria-hidden="true" />

      <div className="container video-band__content">
        <div className="video-band__inner">
          <h2 className="video-band__title">
            Where every life is <em>nurtured</em>
          </h2>
          <p className="video-band__text">
            On our farm, the gentle bond between a calf and its mother is a daily
            reminder of the care we pour into all we grow — natural, humane and
            rooted in respect for every living thing.
          </p>
        </div>
      </div>
    </section>
  );
}
